__turbopack_context__.v({
  "root": "style-module-scss-module__0oKcGa__root",
  "root__content": "style-module-scss-module__0oKcGa__root__content",
  "root__img": "style-module-scss-module__0oKcGa__root__img",
  "root__subtitle": "style-module-scss-module__0oKcGa__root__subtitle",
  "root__title": "style-module-scss-module__0oKcGa__root__title",
});
